module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="'+
((__t=( metricDivId ))==null?'':__t)+
'" class="xFormMetricsWrapper">\n    <div class="xMetricWrapper">\n        <p class="xFormMetricTitle">'+
((__t=( label ))==null?'':_.escape(__t))+
'</p>\n        <div class="xMetricGraphWrapper">'+
((__t=( metricsHtml ))==null?'':__t)+
'</div>\n    </div>\n</div>';
}
return __p;
};
